import Translated from './Translated';

export const VehicleInfo = ({ category }) => {
  return (
    <div>
      <p>
        <Translated translationKey={'vehicle_info_common'} html={true} />
      </p>
      <p>
        <Translated translationKey={`vehicle_info_${category}`} html={true} />
      </p>
    </div>
  );
}

export default VehicleInfo;
